import { render, staticRenderFns } from "./omt-input-box.vue?vue&type=template&id=c3350856&scoped=true&"
import script from "./omt-input-box.vue?vue&type=script&lang=js&"
export * from "./omt-input-box.vue?vue&type=script&lang=js&"
import style0 from "./omt-input-box.vue?vue&type=style&index=0&id=c3350856&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3350856",
  null
  
)

export default component.exports